import React, { useState, useEffect } from "react";
import "./MarqueeImageComponent.css";
import { BASEAPIURL, token } from "../env";
import person from "../Images/Avatar.png";

const MarqueeImageComponent = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        const response = await fetch(`${BASEAPIURL}/Birth_MerrageList`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ tokenData: token }),
          signal: controller.signal,
        });

        const result = await response.json();
        console.log("API Response:", result);

        const memberList =
          Array.isArray(result?.data) ? result.data :
            Array.isArray(result?.BirthList) ? result.BirthList :
              Array.isArray(result) ? result :
                [];

        console.log("Parsed member list:", memberList);

        if (memberList.length > 0) {
          setData(memberList);
        }
        // No else block needed — we’ll return null instead of showing an error
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Fetch error:", err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => controller.abort();
  }, []);

  // Handle loading
  if (loading) return null;

  // Hide component entirely if no data
  if (data.length === 0) return null;

  // Render component if data exists
  return (
    <div className="marquee-scroll-wrapper">
      <h3 className="text-center text-danger mb-4">Member's Birthday / Anniversary</h3>
      <div className="marquee-scroll-track">
        {[...data, ...data].map((member, index) => (
          <div className="marquee-card" key={index}>
            <div
              className="member-card border rounded text-center  bg-light shadow-sm h-100 d-flex flex-column justify-content-between"
              style={{ minHeight: "80px" }} // optional: consistent card height
            >
              <div>
                <div className="d-flex justify-content-center">
                  <img
                    src={
                      member?.ImageBase64?.startsWith("data:image")
                        ? member.ImageBase64
                        : person
                    }
                    alt={member?.MemName || "Member"}
                    className="rounded-circle mb-2"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <p className="truncate-2-lines form-control-sm mb-2">
                  {member?.MemName?.trim() || "No Name Available"}
                </p>

                <p
                  className="fst-italic text-center message-text"
                  style={{
                    fontSize: "0.9rem",
                    minHeight: "20px",
                    color: member?.Message?.includes("Happy Wedding Anniversary!")
                      ? "orange"
                      : "deeppink",
                  }}
                >
                  {member?.Message ? `"${member.Message}"` : ""}
                </p>
              </div>
            </div>

          </div>
        ))}
      </div>

      <style>
        {`
            .truncate-2-lines {
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              font
            }
        `}
      </style>
    </div>
  );
};

export default MarqueeImageComponent;
